<template>
    <div class="panel panel-default person-card" :class="{'person-card--empty-contact-methods': !contactMethods.length}">
        <div class="panel-body">
            <div class="person-card__basic-info">
                <h3>
                    {{ person.data.name }}
                </h3>

                <router-link :to="'/companies/' + person.data.company.id" v-if="person.data.company">
                    {{ person.data.company.name }}
                </router-link>

                <div v-if="isContact" class="person-card__basic-info-contact-info">
                    <span v-if="isAdvertisingContact" class="label label-info">
                        Advertising Contact
                    </span>

                    <span v-if="isDoubleContact">&nbsp;</span>

                    <span v-if="isSubscriptionContact" class="label label-success">
                        Subscription Contact
                    </span>
                </div>
            </div>

            <div v-if="contactMethods.length" class="person-card__contact-methods">
                <template v-for="(contactMethod, index) in contactMethods">
                    <span v-if="contactMethod === 'email'">
                        <i class="fa fa-envelope"></i> <a :href="'mailto:' + person.data.email">{{ person.data.email }}</a>
                    </span>

                    <span v-if="contactMethod === 'cell-phone'">
                        <i class="fa fa-mobile-alt"></i> {{ person.data.cell_phone }}
                    </span>

                    <span v-if="contactMethod === 'work-phone'">
                         <i class="fa fa-phone"></i> {{ person.data.work_phone }}
                    </span>

                    {{ index !== contactMethods.length - 1 ? '&middot;' : '' }}
                </template>
            </div>

            <div v-if="person.data.address" class="text-center" style="padding: 10px 0">
                {{ person.data.address.street_address }}<br>
                {{ person.data.address.zip_code }} {{ person.data.address.city }}<br>
                {{ person.data.address.verbose_country }}
            </div>

            <div v-if="portals.length" class="text-center" style="padding: 10px 0; background-color: #eeeeee">
                <span v-for="(portal, index) in portals">
                    <a :href="portal.base_url + '/user/' + portal.pivot.external_id">
                        {{ portal.name }}
                    </a>

                    <span v-if="index !== portals.length - 1">
                        &middot;
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<style>
    .person-card .panel-body {
        padding: 0;
    }

    .person-card__basic-info {
        text-align: center;
        padding: 40px 0;
    }

    .person-card__basic-info h3 {
        margin: 10px 0;
    }

    .person-card--empty-contact-methods .person-card__basic-info {
        border-bottom: 1px solid #eeeeee;
    }

    .person-card--empty-contact-methods .person-card__basic-info .person-card__basic-info-contact-info {
        margin-top: 10px;
    }

    .person-card__contact-methods {
        text-align: center;
        padding: 10px 0;
        background-color: #eeeeee;
    }
</style>

<script>
    export default {
        props: ['person'],

        computed: {
            isContact() {
                return this.isAdvertisingContact || this.isSubscriptionContact
            },

            isDoubleContact() {
                return this.isAdvertisingContact && this.isSubscriptionContact
            },

            isAdvertisingContact() {
                return this.person.data.advertising_responsibilities.length
            },

            isSubscriptionContact() {
                return this.person.data.subscription_responsibilities.length
            },

            portals() {
                return this.person.data.portals.filter(person => person.pivot.external_id)
            },

            contactMethods() {
                let methods = []

                if(this.person.data.email) {
                    methods.push('email')
                }

                if(this.person.data.cell_phone) {
                    methods.push('cell-phone')
                }

                if(this.person.data.work_phone) {
                    methods.push('work-phone')
                }

                return methods
            }
        }
    }
</script>
